

import React, { useState } from 'react';
import './PCI.css'; 

const PCI = () => {
 
    const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);

 
    const pciApprovalPdfUrl = '/pci-image.pdf';


    const openPdfViewer = (pdfUrl) => {
        setSelectedPdfUrl(pdfUrl);
    };

  
    const closePdfViewer = () => {
        setSelectedPdfUrl(null);
    };

    return (
        <div className="pci-page-container">
            <h2>PCI Affiliation</h2>
            <p className="pci-intro-text">
                
            </p>
            
            <div className="pci-document-section">
                <button
                    className="view-document-btn"
                    onClick={() => openPdfViewer(pciApprovalPdfUrl)}
                >
                    Click to View Document
                </button>
            </div>

            
            {selectedPdfUrl && (
                <div className="fullscreen-overlay" onClick={closePdfViewer}>
                    <button className="close-button" onClick={closePdfViewer}>&times;</button>
                    <iframe
                        className="pdf-viewer-iframe"
                        src={`${selectedPdfUrl}#toolbar=0`}
                        title="PCI Approval Document"
                        frameBorder="0"
                    />
                </div>
            )}
        </div>
    );
};

export default PCI;